const contentTypes = {
	REPORT: 1,
	MULTIMEDIA: 2,
	NEWS: 3,
	INSIGHT_BITE: 5,
	HUB: 7,
	LIVE_EVENT: 8,
};

const humanReadableContentTypes = {
	1: 'Report',
	2: 'Multimedia',
	3: 'News',
	5: 'Insight Bite',
	7: 'Hub',
	8: 'Live Event',
};

const assetTypes = {
	[contentTypes.REPORT]: {
		PDF: 1,
		POWERPOINT: 2,
		ICON: 3,
		CUSTOM: 4,
	},
	[contentTypes.MULTIMEDIA]: {
		RSVP_URL: 1,
		AUDIO_FILE: 2,
		WEBINAR_URL: 3,
		VIDEO_URL: 4,
		ICS_FILE: 5,
	},
	[contentTypes.INSIGHT_BITE]: {
		IMAGE: 1,
	},
	[contentTypes.LIVE_EVENT]: {
		POWERPOINT: 1,
		PDF: 2,
		ICON: 3,
	},
};

const cmsIndices = {
	[contentTypes.REPORT]: 'reports',
	[contentTypes.MULTIMEDIA]: 'multimedia',
	[contentTypes.NEWS]: 'news',
	[contentTypes.INSIGHT_BITE]: 'insightBites',
	[contentTypes.HUB]: 'hubs',
	[contentTypes.LIVE_EVENT]: 'liveEvents',
};

const searchParamToContentTypeID = {
	reports: contentTypes.REPORT,
	multimedia: contentTypes.MULTIMEDIA,
	news: contentTypes.NEWS,
	insightBites: contentTypes.INSIGHT_BITE,
	hubs: contentTypes.HUB,
	liveEvents: contentTypes.LIVE_EVENT,
};

const metaContentTypes = {
	[contentTypes.REPORT]: 'report',
	[contentTypes.MULTIMEDIA]: 'multimedia',
	[contentTypes.NEWS]: 'news',
	[contentTypes.INSIGHT_BITE]: 'insightBite',
	[contentTypes.HUB]: 'hub',
	[contentTypes.LIVE_EVENT]: 'liveEvent',
};

const contentTypeToID = {
	InsightBite: contentTypes.INSIGHT_BITE,
	Report: contentTypes.REPORT,
	Multimedia: contentTypes.MULTIMEDIA,
	NewsArticle: contentTypes.NEWS,
	Hub: contentTypes.HUB,
	LiveEvent: contentTypes.LIVE_EVENT,
};

const contentTypeIDtoType = {
	[contentTypes.REPORT]: 'Report',
	[contentTypes.MULTIMEDIA]: 'Multimedia',
	[contentTypes.NEWS]: 'NewsArticle',
	[contentTypes.INSIGHT_BITE]: 'InsightBite',
	[contentTypes.HUB]: 'Hub',
	[contentTypes.LIVE_EVENT]: 'LiveEvent',
};

module.exports = {
	contentTypes,
	humanReadableContentTypes,
	assetTypes,
	cmsIndices,
	searchParamToContentTypeID,
	metaContentTypes,
	contentTypeToID,
	contentTypeIDtoType,
};
